import React from 'react'
import { Link } from 'react-router-dom'

class ForCaptainSideNavBar extends React.Component {
  render() {
    return (
      <nav
        className="pcoded-navbar noprint"
        id="admin_menu"
      >
        <div className="pcoded-inner-navbar main-menu">
          <ul className="pcoded-item pcoded-left-item">
            <li className="">
              <Link to="/">
                <span className="pcoded-micon">
                  <i className="feather icon-home"></i>
                </span>
                <span className="pcoded-mtext">Dashboard</span>
              </Link>
            </li>
            <li className=" ">
              <Link to="/booking-order">
                <span className="pcoded-micon edit">
                  <i className="icofont icofont-cart-alt"></i>
                </span>
                <span className="pcoded-mtext">Bookings</span>
              </Link>
            </li>
            <li className="">
              <Link to="/boat-Captain">
                <span className="pcoded-micon">
                  <i className="icofont icofont-police"></i>
                </span>
                <span className="pcoded-mtext">Boat Captain</span>
              </Link>
            </li>
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <i className="icofont icofont-sail-boat-alt-1"></i>
                </span>
                <span className="pcoded-mtext">Boat Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className=" ">
                  <Link to="/boatsmaster/Boat">
                    <span className="pcoded-mtext">Boat</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/boatsmaster/Yacht">
                    <span className="pcoded-mtext">Yacth</span>
                  </Link>
                </li>
              </ul>
            </li>
            {/* <li className="">
              <Link to="/category">
                <span className="pcoded-micon">
                  <i className="icofont icofont-sail-boat-alt-2"></i>
                </span>
                <span className="pcoded-mtext">Boat Category</span>
              </Link>
            </li> */}
          </ul>
        </div>
      </nav>
    )
  }
}

export default ForCaptainSideNavBar
